module.exports = __webpack_public_path__ + "static/media/ruby.8cce891d.jpg";